<div
  class="status-button-wrapper"
  [ngbTooltip]="pspSignatureError || customerSignatureError ? errorStatusTooltip : undefined"
>
  <div
    class="status-button-body"
    [ngClass]="{ 'animated-border': isInAQueue, 'static-error': isErrorBorder, 'static-warning': isWarningBorder }"
  ></div>
  <div class="status-button-icon">
    <i class="fa-solid fa-file-signature"></i>
  </div>
  <span
    *ngIf="pspSignatureError || customerSignatureError"
    class="position-absolute translate-middle badge rounded-circle bg-warning status-button-badge"
  >
    <span class="fw-bold text-dark">!</span>
  </span>
</div>

<ng-template #errorStatusTooltip>
  <div
    class="p-1"
    *ngIf="pspSignatureError || customerSignatureError"
  >
    <p class="text-start fw-bold">
      {{
        (pspSignatureError && customerSignatureError ? 'operations.signErrorHeaderBoth' : 'operations.signErrorHeader')
          | translate
      }}
    </p>
    <div
      class="d-flex gap-2"
      [ngClass]="isPsp ? 'flex-column-reverse' : 'flex-column'"
    >
      <!--flex-column-reverse class is used above to display contract partner status first-->
      <div
        class="text-start m-0"
        *ngIf="pspSignatureError"
      >
        <base-sign-contract-error-status-tooltip
          [title]="
            isPsp
              ? 'externalEmployees.contractStatus.tooltip.yourCompany'
              : 'externalEmployees.contractStatus.tooltip.partner'
          "
          [signedBy]="contractSignedByPSP"
          [signedAt]="contractSignedAtPSP"
        ></base-sign-contract-error-status-tooltip>
      </div>
      <div
        class="text-start m-0"
        *ngIf="customerSignatureError"
      >
        <base-sign-contract-error-status-tooltip
          [title]="
            isPsp
              ? 'externalEmployees.contractStatus.tooltip.partner'
              : 'externalEmployees.contractStatus.tooltip.yourCompany'
          "
          [signedBy]="contractSignedByCustomer"
          [signedAt]="contractSignedAtCustomer"
        ></base-sign-contract-error-status-tooltip>
      </div>
    </div>
  </div>
</ng-template>
